import { CityState, DataSource, HorizontalSpacer, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRecurringAvailableTractor extends Layout {
    citystateLoadTo: CityState;
    citystateLocation: CityState;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    sourceRecurringAvailableTractor: DataSource;
    switchSwitchFriTeam: Switch;
    switchSwitchMonTeam: Switch;
    switchSwitchSatTeam: Switch;
    switchSwitchSunTeam: Switch;
    switchSwitchTeamTues: Switch;
    switchSwitchThursTeam: Switch;
    switchSwitchWedTeam: Switch;
    textboxCarrier: Textbox;
    textboxComments: Textbox;
    textboxContactEmail: Textbox;
    textboxContactFax: Textbox;
    textboxContactName: Textbox;
    textboxContactPhone: Textbox;
    textboxDispatcher: Textbox;
    textboxDistance: Textbox;
    textboxEndDate: Textbox;
    textboxExpireTractors: Textbox;
    textboxFriTrailer: Textbox;
    textboxFriday: Textbox;
    textboxMonType: Textbox;
    textboxMonday: Textbox;
    textboxSat: Textbox;
    textboxSatTrailer: Textbox;
    textboxStartDate: Textbox;
    textboxSunType: Textbox;
    textboxSunday: Textbox;
    textboxThursTrailer: Textbox;
    textboxThursday: Textbox;
    textboxTractorStatus: Textbox;
    textboxTuesTrailer: Textbox;
    textboxTuesday: Textbox;
    textboxWed: Textbox;
    textboxWenTrailer: Textbox;
}
